/**
 * Application configuration for the player project
 * @type {{develop: boolean}}
 */

module.exports = {

    // Player config
    playerElementId: 'starzplayer', // The ID of the div of the client
    environment: 'production', // Possible values: 'development', 'test', production'.
    // esbUrl: 'https://lgi-dev-api.aws.playco.com/api/v0.2/',
    // recEngineUrl: 'https://lgi-dev-api.aws.playco.com/api/v1.0/',
    // recEngineStaticUrl: 'https://lgi-dev-api.aws.playco.com/api/v1.0/',

    esbUrl: 'https://lgi-api-prod.aws.playco.com/api/v0.2/',
    recEngineUrl: 'https://lgi-api-prod.aws.playco.com/api/v1.0/',
    recEngineStaticUrl: 'https://lgi-api-prod.aws.playco.comm/api/v1.0/',

    // HTTPS
    httpCdnUrl: 'http://li-cdn-lb.lionsgateplay.com',
    httpsCdnUrl: 'https://lgi-img-cdn-lb.lionsgateplay.com',
    httpJitUrl: 'http://li-jit-cdn-lb.lionsgateplay.com',
    httpsJitUrl: 'https://lgi-jit-usp.lionsgateplay.com'

};



// WEBPACK FOOTER //
// ./src/config.js